import { format, isValid, parseISO } from "date-fns";
import { fullDateFormatWithTime } from "@common/helpers/date";

// Copy for the "this Applied event was later reverted" command-island action.
// Kept as pure constants so the drawer/island stay testable and the exact,
// spec-pinned strings live in one place.
export const REVERTED_ACTIVITY_TOOLTIP =
    "This application has already been undone.";
export const VIEW_REVERTED_ACTIVITY_LABEL = "View reverted activity";

const REVERTED_PREVIEW_STATEMENT =
    "This template apply was reverted for this entity";

// In-panel statement for an active entity whose apply has already been undone:
// the preview still lists what the apply once changed, which would otherwise read
// as the entity's current chart of accounts. Actor and timestamp come straight
// from the loaded detail and are dropped when absent or unparseable — never
// guessed. Returns null when the entity was not reverted.
export function getRevertedPreviewNotice({
    revertedAt,
    revertedByUserName,
}: {
    revertedAt: string | null;
    revertedByUserName: string | null;
}): string | null {
    if (!revertedAt) {
        return null;
    }
    const revertedDate = parseISO(revertedAt);
    if (!isValid(revertedDate)) {
        return `${REVERTED_PREVIEW_STATEMENT}.`;
    }
    const when = format(revertedDate, fullDateFormatWithTime);
    if (!revertedByUserName) {
        return `${REVERTED_PREVIEW_STATEMENT} on ${when}.`;
    }
    return `${REVERTED_PREVIEW_STATEMENT} on ${when} by ${revertedByUserName}.`;
}
